// extracted by mini-css-extract-plugin
export default {"footerButtons":"not-found_footerButtons__D5gak","link":"not-found_link__4zd28"};